import Balance from '~/sha256/Stats/components/Balance';
import WarningGram from '~/sha256/Stats/components/WarningGram';
import { useIntl } from 'react-intl'
import ShortStats from '~/sha256/Stats/components/ShortStats';
import Notification from '@/shared/ui/Notification';
import { useMinerAccount } from '@/processes/MinerAccounts';
import { useWatcherLink } from '@/processes/WatcherLink';
import { openNewTab } from '@/shared/utils/openLink'
import { WalletSetup } from '~/sha256/Stats';
import { useGetWalletAddressQuery } from '@/shared/api/Stats'
import MinerAddress from "@/entities/MinerAddress";
import TerminatedGramWarning from '~/sha256/Stats/components/TerminatedGramWarning';
import { getSettingsLink } from '@/shared/constants/links';
import { useNavigation } from '@/processes/Router';

type StatsProps = {
  className: string;
}

const Stats = (props: StatsProps) => {
  const {
    className = '',
  } = props;
  const intl = useIntl();
  const { account, coin, miner, isSupport } = useMinerAccount();
  const { isWatcherLink } = useWatcherLink();
  const { navigate } = useNavigation();
  const {
    isError,
    isSuccess,
  } = useGetWalletAddressQuery({ account, miner, coin }, { skip: !account || miner })

  return (
    <div className={className}>
      <div className="flex justify-end mb-4">
        <TerminatedGramWarning />
      </div>

      <div className="flex justify-between flex-col md:flex-row gap-4">
        {/* for watcher link, just show balance */}
        {isWatcherLink ? (
          <Balance className='mb-6 md:order-1'/>
        ) : (
          <>
            {/* If api return 404, wallet address not set
            TODO: extend this logic when more coins will be added */}
            {miner.length === 0 && isError ? (
              <WalletSetup className='mb-6 w-full md:order-2 flex justify-center md:justify-end md:w-2/5'/>
            ) : null}
            <Balance className='mb-6 md:order-1'/>
            {isSuccess ? (
                <div className="mb-4 w-full order-0 md:order-2 flex justify-center items-center md:justify-end md:w-2/5 flex-grow">
                  {!!miner.length ? (<MinerAddress className='mb-4 w-full md:w-[320px]' address={miner}/>)
                    :
                    <div className="flex flex-col flex-grow items-end">
                      <WarningGram />

                      <Notification
                        className='w-fit'
                        innerClassName="w-fit"
                        withIcon={false}
                        buttonText={intl.formatMessage({ id: 'account.settings' })}
                        buttonOnClick={() => {
                          const settingsLink = getSettingsLink(coin, 'payout', {
                            account,
                            miner,
                            support: isSupport ? 'true' : undefined,
                          });
                          navigate(settingsLink);
                        }}
                      />
                    </div>
                  }
                </div>
            ) : (!!miner.length) ? (
                <div className="mb-4 w-full order-0 md:order-2 flex justify-center items-center md:justify-end md:w-2/5 flex-grow">
                  <MinerAddress className='mb-4 w-full md:w-[320px]' address={miner}/>
                </div>)
              : null}
          </>
        )}
      </div>
      <ShortStats/>
    </div>
  );
}

export default Stats;
